import { gql } from "@apollo/client";

import type {
  MapAgreementType,
  UsersMapAgreementStatusTypes,
} from "@clinic/shared/data/types/Maps.d";
import type { BrandFragment } from "@shared/data/fragments/BrandFragment/BrandFragment.fragment";

const MAP_AGREEMENT = gql`
  fragment MapAgreement on MapAgreement {
    id
    activatedAt
    agreementType
    agreementUrl
    createdAt
    statusForStore
    updatedAt
    brandsMapAgreements {
      id
      agreementUrl
      statusForStore
      brand {
        id
        name
      }
    }
  }
`;

type BrandSplinter = Pick<BrandFragment, "id" | "name">;

type BrandsMapAgreement = {
  id: string;
  agreementUrl: string;
  statusForStore: UsersMapAgreementStatusTypes;
  updatedAt: string;
  brand: BrandSplinter;
};

interface MapAgreement {
  id: string;
  activatedAt: string;
  agreementType: MapAgreementType;
  agreementUrl: string;
  createdAt: string;
  statusForStore: UsersMapAgreementStatusTypes;
  updatedAt: string;
  brandsMapAgreements: BrandsMapAgreement[];
}

export type { MapAgreement };
export { MAP_AGREEMENT };
